<!--__AdminSidebar.vue-->
<template>
  <!-- 綁定 .open class，根據 isSidebarOpen 動態顯示/隱藏 -->
  <aside class="admin-sidebar" :class="{ open: isSidebarOpen }">
    <div class="sidebar-logo">
      <h2>後台管理</h2>
      <!-- 手機版關閉按鈕 -->
      <button class="close-btn" @click="$emit('closeSidebar')">✕</button>
    </div>
    <!-- <div v-if="adminname" @click="logout" class="logout">
      <span>{{ adminname }} 登出</span>
    </div> -->
    <nav class="sidebar-menu">
      <ul>
        <li v-for="item in menuItems" :key="item.path" :class="{ active: isActive(item.path) }">
        <router-link :to="item.path">
          <div class="icon-text-group">
            <font-awesome-icon v-if="item.icon" :icon="item.icon" />
            <span>{{ item.label }}</span>

          </div>
        </router-link>
      </li>
      <li class="company">
        {{$COMPANY_NAME}} ( {{$COMPANY_NAMEn}} )
      </li>
      <li class="company">
        {{ $COMPANY_TAXID }}
      </li>
      </ul>
    </nav>
    <div v-if="adminname" @click="logout" class="logout">
      <span>{{ adminname }} 登出</span>
    </div>
  </aside>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAdminSysTempStore } from '@/store/adminSysTempStore.js'
import axios from 'axios'


export default {
  name: 'AdminSidebar',
  data() {
    return {
      //isSidebarOpen: false,
    }
  },
  props: {
    isSidebarOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async logout() {
      const res = await axios.get('/api/admin/logout')
      if (res.data.success) {
        const useAdminSysTemp = useAdminSysTempStore();
        await useAdminSysTemp.fetchLoggedOff();
        this.adminname = null;
        // 登出成功 
        this.$router.push('/admin/login')
      }
    }
  },
  async beforeCreate() {

  },
  async created() {
    const useAdminSysTemp = useAdminSysTempStore();
    await useAdminSysTemp.fetchAdminCheckLogin();
    this.adminname = useAdminSysTemp.adminname;
  },
  setup() {
    // 取得路由
    const route = useRoute()
    // 取得 store
    const useAdminSysTemp = useAdminSysTempStore()

    // 透過 computed 讓 adminname 成為「活的、可即時更新」的屬性
    const adminname = computed(() => useAdminSysTemp.adminname)

    // 在掛載時呼叫檢查登入，確保 adminname 會被正確更新
    onMounted(async () => {
      await useAdminSysTemp.fetchAdminCheckLogin()
    })

    // 側邊欄選單
    const menuItems = ref([
      { label: '儀表板', icon: 'fas fa-gauge', path: '/admin' },
      { label: '會員管理', icon: 'fas fa-users', path: '/admin/users' },
      { label: '訂單管理', icon: 'fas fa-shopping-cart', path: '/admin/orders' },
      { label: '商品管理', icon: 'fas fa-boxes', path: '/admin/products' },
      { label: '活動管理', icon: 'fas fa-tag', path: '/admin/campaigns' },
      { label: '活動公告', icon: 'fas fa-bullhorn', path: '/admin/promotions' },
      { label: '通知管理', icon: 'fas fa-bell', path: '/admin/notifications' },
      { label: '內文管理', icon: 'fas fa-file-code', path: '/admin/htmlpages' },
      { label: '內文圖片', icon: 'fas fa-images', path: '/admin/htmlimages' },
      { label: '海報管理', icon: 'fas fa-book', path: '/admin/adposters' },
      { label: '首頁圖片', icon: 'fas fa-images', path: '/admin/homeImages' },
      { label: '相關設置', icon: 'fas fa-cogs', path: '/admin/settings' },
      { label: '圖片管理', icon: 'fas fa-images', path: '/admin/images' },
      // ── 美容預約管理 ──────────────────────────────
      { label: '店家管理', icon: 'fas fa-store', path: '/admin/booking-stores' },
      { label: '預約總覽', icon: 'fas fa-calendar-check', path: '/admin/booking-reservations' },
      { label: '平台公告', icon: 'fas fa-bullhorn', path: '/admin/announcements' },
      // ── 合作夥伴分潤 ─────────────────────────────
      { label: '合作夥伴', icon: 'fas fa-handshake', path: '/admin/affiliates' },
      { label: '提領管理', icon: 'fas fa-money-bill-wave', path: '/admin/affiliate-payouts' },
    ])


    // 判斷當前路由是否屬於 item.path
    const isActive = (path) => route.path.startsWith(path)

    return {
      adminname,
      menuItems,
      isActive
    }
  }
}
</script>

<style scoped>
.admin-sidebar {
  width: 240px;
  /* 桌面版寬度 */
  margin: 0;
  padding: 0;

  min-height: 100vh;
  /* 讓側邊欄高度鋪滿螢幕 */
  background-color: #2E3A59;
  color: #fff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  /* 對應手機版可改用 fixed 顯示 */
}

/* 側邊欄 Logo + 關閉按鈕 */
.sidebar-logo {
  padding: 1rem;
  text-align: center;
  background-color: #1F2B46;
  font-size: 1.2rem;
  font-weight: bold;
  color: #ffffff;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 關閉按鈕：手機版才需要 */
.close-btn {
  font-size: 1.2rem;
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: none;
  /* 電腦版預設不顯示 */
}

/* 菜單部分 */
.sidebar-menu {
  flex: 1;
  margin-top: 1rem;
  overflow-y: auto;
  /* 側邊欄超出畫面時可捲動 */
}

.sidebar-menu ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.sidebar-menu li {
  margin-bottom: 0.5rem;
}

.sidebar-menu li a {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  color: #ffffff;
  text-decoration: none;
  transition: background-color 0.2s;
}

.sidebar-menu li a:hover {
  background-color: #3b4b6b;
}

.sidebar-menu li a i {
  margin-right: 0.5rem;
}

/* 高亮當前頁面 */
.sidebar-menu li.active>a {
  background-color: #46567a;
}

.logout {
  margin-top: auto;
  background-color: #e74c3c;
  color: #ecf0f1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  cursor: pointer;
  /* 添加指標樣式 */
}

.logout:hover {
  background-color: #c0392b;
}


li.company{
  margin-top: auto;
  background-color: #1F2B46;
  color: #ecf0f1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}
li.company:hover {
  background-color: #0c101b;
}

.icon-text-group {
  display: flex;
  align-items: center;
  gap: 8px;
}


/* ---------- RWD: 手機 / 平板 ---------- */
@media (max-width: 1425px) {
  .admin-sidebar {
    position: fixed;
    left: -240px;
    /* 手機版預設藏在左側 */
    top: 0;
    height: 100%;
    transition: left 0.3s ease;
    z-index: 1001;
    /* 以免被其他元素蓋住 */
  }

  /* 當 .open 時就顯示 (left: 0) */
  .admin-sidebar.open {
    left: 0;
  }

  /* 手機版顯示關閉按鈕 */
  .close-btn {
    display: block;
  }
}
</style>